// i18n.js
import { sidebarTranslations } from '@volumental/translations';
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    resources: sidebarTranslations,
    detection: {
      order: [
        'querystring', // Looks at the 'lng' query parameter.
        'navigator',
        'cookie',
        'localStorage',
        'htmlTag',
        'path',
        'subdomain',
      ],
    },
  });

export default i18next;
